export default __webpack_public_path__ + "static/media/DebitEntry_Dark2.dce73fce.svg";